import { render, staticRenderFns } from "./CopyBox.vue?vue&type=template&id=bfe70aba&scoped=true&"
import script from "./CopyBox.vue?vue&type=script&lang=ts&"
export * from "./CopyBox.vue?vue&type=script&lang=ts&"
import style0 from "./CopyBox.vue?vue&type=style&index=0&id=bfe70aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe70aba",
  null
  
)

export default component.exports